import { FormsFilterType } from 'api/FormsAPI';

export const formsKeys = {
  getForms: ({ companyId, filters }: { companyId: string; filters?: FormsFilterType[] }) => [
    'forms',
    companyId,
    filters,
  ],
};
